const {
  zipCodeRegexNumeric,
  onlyNumericNormalize,
  SPACE
} = require('../helpers');

const states = {
  Auckland: 'Auckland',
  'Bay of Plenty': 'Bay of Plenty',
  Canterbury: 'Canterbury',
  'Chatham Islands Territory': 'Chatham Islands Territory',
  Gisborne: 'Gisborne',
  "Hawke's Bay": "Hawke's Bay",
  Marlborough: 'Marlborough',
  'Manawatu-Wanganui': 'Manawatu-Wanganui',
  Nelson: 'Nelson',
  Northland: 'Northland',
  Otago: 'Otago',
  Southland: 'Southland',
  Tasman: 'Tasman',
  Taranaki: 'Taranaki',
  Waikato: 'Waikato',
  Wellington: 'Wellington',
  'West Coast': 'West Coast'
};

const stateOptions = [];
Object.keys(states).forEach((key) => {
  stateOptions.push({ value: key, name: states[key] });
});

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 4);

exports.countryDefinition = {
  country: 'New Zealand',
  code: 'NZ',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Address' },
    address2: { label: 'Address 2' },
    city: { label: 'City' },
    stateCode: {
      label: 'Region',
      width: 0.5,
      array: stateOptions,
      type: 'array'
    },
    zipCode: {
      label: 'Postal Code',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  states,
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city'],
    ['stateCode', SPACE, 'zipCode']
  ],
  formFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city'],
    ['stateCode', 'zipCode']
  ],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    { field: 'stateCode' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(4)),
      error: 'Must be 4 characters, 1234'
    }
  ]
};
